import Vue, { ComponentOptions, VueConstructor, CreateElement } from 'vue';

import { ModuleTree } from 'vuex/types';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router/types';
import errorhandler from '~/plugin/errorHandler';
import { RootState } from '~/types/store.d';
import store from '~/store/store';
// 初始化渲染，store，全局方法，i18deng，返回一个实例，挂载由入口自己去挂载
function configGlobalPlugin(): void {
  Vue.use(VueI18n);
  Vue.use(errorhandler);
}
export default function createApp(
  appName: string,
  layout: VueConstructor<Vue>,
  storeModules?: ModuleTree<RootState>,
  router?: VueRouter,
  options?: ComponentOptions<Vue>,
): Vue {
  // config global plugin
  configGlobalPlugin();
  // confige language
  const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
      en: {
        message: {
          hello: '{msg} world',
        },
      },
    },
  });
  // register vuex module
  if (storeModules) {
    const storeConfig = { ...storeModules };
    Object.keys(storeConfig).forEach(item => {
      store.registerModule(item, storeConfig[item]);
    });
  }

  return new Vue({
    name: appName,
    i18n,
    store,
    router,
    render: (h: CreateElement) => h(layout),
    ...options,
  });
}
